import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AppleProfilePresetType, PresetModelType } from '@era/stores';
import { NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import {
  ContextMenuComponent,
  PanelComponent,
  PanelHeaderComponent,
  SkSpinner3Component,
  TitleH4Component,
} from '@rocksoft/cdk';
import { SettingsProfilePresetListItemComponent } from './settings-profile-preset-list-item/settings-profile-preset-list-item.component';

@Component({
  selector: 'ml-mdm-settings-profile-preset-list',
  templateUrl: './settings-profile-preset-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PanelComponent,
    PanelHeaderComponent,
    TitleH4Component,
    ContextMenuComponent,
    NgbDropdownItem,
    RouterLink,
    SkSpinner3Component,
    SettingsProfilePresetListItemComponent,
  ],
})
export class SettingsProfilePresetListComponent {
  readonly presets = input.required<PresetModelType<AppleProfilePresetType>[]>();
  readonly profileType = input.required<AppleProfilePresetType>();
  readonly headerLabel = input('Name');
  readonly displayField = input(''); // Optional override for display field
  readonly deletePreset = output<PresetModelType<AppleProfilePresetType>>();
  public editEnabled = false;

  public toggleEditPresets() {
    this.editEnabled = !this.editEnabled;
  }

  public getDisplayField(): string {
    const displayField = this.displayField();
    if (displayField) {
      return displayField;
    }
    // Default display fields based on profile type
    if (this.profileType() === 'wifi-profile') {
      return 'SSID_STR';
    }
    return 'id';
  }
}
